import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.function.bind.js";
import "core-js/modules/es6.object.assign.js";

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import * as React from "react";

function WeatherWind(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4 10a1 1 0 010-2h8a2 2 0 000-4c-.55 0-1.05.22-1.41.59a.973.973 0 01-1.42 0c-.39-.39-.39-1.03 0-1.42A4 4 0 1112 10H4zm15 2a1 1 0 000-2c-.28 0-.53.11-.71.29a.996.996 0 01-1.41 0c-.38-.39-.38-1.02 0-1.41a2.993 2.993 0 014.241-.001A3 3 0 0119 14H5a1 1 0 010-2h14zm-1 6H4a1 1 0 010-2h14a3 3 0 11-2.12 5.12c-.38-.39-.38-1.02 0-1.41a.996.996 0 011.41 0c.18.18.43.29.71.29a1 1 0 000-2z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(WeatherWind);
export default ForwardRef;